<template>
  <w-icon-wrapper
    :height='16'
    :width='24'
    icon-name='work-hamburger-menu-icon'
    view-box='0 0 24 16'
  >
    <g
      id='_55_Hamburger_Menu_Icon'
      data-name='55 Hamburger Menu_Icon'
      transform='translate(0 -4)'
    >
      <rect
        id='Rechteck_4025'
        data-name='Rechteck 4025'
        fill='currentColor'
        height='2'
        transform='translate(0 4)'
        width='24'
      />
      <rect
        id='Rechteck_4026'
        data-name='Rechteck 4026'
        fill='currentColor'
        height='2'
        transform='translate(0 11)'
        width='24'
      />
      <rect
        id='Rechteck_4027'
        data-name='Rechteck 4027'
        fill='currentColor'
        height='2'
        transform='translate(0 18)'
        width='24'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconHamburgerMenu' };
</script>
